import { render } from "./MoveOrdersDialog.vue?vue&type=template&id=264e79c0&scoped=true"
import script from "./MoveOrdersDialog.vue?vue&type=script&lang=js"
export * from "./MoveOrdersDialog.vue?vue&type=script&lang=js"

import "./MoveOrdersDialog.vue?vue&type=style&index=0&id=264e79c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264e79c0"]])

export default __exports__